// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"8a4d962b","311":"162ff599","442":"2c68d068","591":"114a4a65","666":"e07ffd0b"}[chunkId] + ".chunk.js";
};